<template lang="pug">
  section#sidebar
    button.close(
        type="button"
        :class="{ 'is-active': sidebar }"
        @click="toggleSidebar"
    )
      svg(
        xmlns="http://www.w3.org/2000/svg" 
        fill="#919192"
        viewBox="0 0 64 64"
      )
          path(
             d="M34.5,32L62.2,4.2c0.7-0.7,0.7-1.8,0-2.5c-0.7-0.7-1.8-0.7-2.5,0L32,29.5L4.2,1.8c-0.7-0.7-1.8-0.7-2.5,0  c-0.7,0.7-0.7,1.8,0,2.5L29.5,32L1.8,59.8c-0.7,0.7-0.7,1.8,0,2.5c0.3,0.3,0.8,0.5,1.2,0.5s0.9-0.2,1.2-0.5L32,34.5l27.7,27.8  c0.3,0.3,0.8,0.5,1.2,0.5c0.4,0,0.9-0.2,1.2-0.5c0.7-0.7,0.7-1.8,0-2.5L34.5,32z"
          )
    nav#cat-menu(v-if="shopCatItems && shopCatItems.length")
      TreeMenu(:items="shopCatItems" :max-depth="4" v-if="! error && loaded" toggle-event="click")
    nav#top-menu(v-if="shopInfoItems && shopInfoItems.length")    
      TreeMenu(:items="shopInfoItems" :max-depth="1" v-if="! error && loaded" toggle-event="click")    
    nav#cms-menu(v-if="cmsItems && cmsItems.length")
      TreeMenu(:items="cmsItems" :max-depth="4" v-if="! error && loaded" toggle-event="click")
    
</template>

<script>
import { get, cloneDeep } from '@/helpers';
import { mapGetters, mapMutations } from 'vuex';

import NestedSet from '@/nested-set-lib';

export default {
    name: 'Sidebar',
    computed: {
        cmsItems() {
            const menu = this.menus.find(menu => menu.key === 'cms-menu');
            let items = get(menu, 'menuItems') || [];
            items = cloneDeep(items);

            if (items.length) {
                return NestedSet.createTree(items);
            }

            return items;
        },
        shopCatItems() {
            const menu = this.menus.find(menu => menu.key === 'product-menu');
            let items = get(menu, 'menuItems') || [];
            items = cloneDeep(items);

            if (items.length) {
                return NestedSet.createTree(items);
            }

            return items;
        },
        shopInfoItems() {
            const menu = this.menus.find(menu => menu.key === 'top-menu');
            let items = get(menu, 'menuItems') || [];
            items = cloneDeep(items);

            if (items.length) {
                return NestedSet.createTree(items);
            }

            return items;
        },
        ...mapGetters({
            menus: 'menus',
            loaded: 'loaded',
            error: 'error',
            sidebar: 'sidebar',
            view: 'view'
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(!this.sidebar);
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility'
        })
    },
    mounted() {
        this.$emit('mounted');
    }
};
</script>

<style lang="sass">

section#sidebar
  background-color: #1a1a1d

  button.close
    @apply text-right w-full
    padding: 22px
    height: 74px
    @screen md
      padding: 20px
      height: 61px
    svg
      @apply inline text-right
      width: 16px
      height: 16px
      &:hover
        fill: #fff

  nav#top-menu
    ul
      li
        &:first-child
          @apply hidden
        a
          background-color: lighten(#000, 14%)
  nav#cms-menu ul li a
    background-color: lighten(#000, 17%)
  nav
    ul.tree-menu
      li
        // &.visible
        & > ul
          &.tree-menu
            border-left: 3px solid rgba(255, 255, 255, .1)
            margin-left: 22px
        a
          padding: 16px 24px
          display: block
          font-size: .75rem
          color: #838384
          font-weight: 400
          text-transform: uppercase
          line-height: 1em
          letter-spacing: 1.5px
          border-top: 1px solid #313134
          .sub-right
            float: right
            transform: rotate(90deg)
          &:hover
            text-decoration: underline
            color: #fff
        &.active a
          color: #fff

        .tree-item
          display: flex
          & > a
            flex-grow: 1
          & > button
            width: 40px
            background: transparent
            border: none
            outline: none
            color: white
            font-size: 1rem
            & > i
              font-family: "Font Awesome 5 Free"
              font-weight: 900
              text-decoration: none
              font-style: normal
              &.is-closed:before
                content: "\f078"
              &.is-open:before
                content: "\f077"
      .show-enter-active, .show-leave-active
        transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease
        transform-origin: left center
        max-height: 500px
        overflow: hidden
      .show-enter, .show-leave-to
        opacity: 0
        max-height: 0
        transform: translateX(-15px)
</style>
